<template>
  <r-panel :disabled="disabled" :title="title">
    <v-row dense>
      <v-col cols="12" md="4" sm="4">
        <r-currency-kind-dropdown :model.sync="value.currencyFrom" label="Spend Currency"/>
      </v-col>
      <v-col cols="12" sm="2" md="2">
        <v-text-field v-model.number="model.amount" label="Amount" hide-details/>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <r-currency-kind-dropdown :model.sync="value.currencyTo" label="Key Currency"/>
      </v-col>
    </v-row>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {AncientTreasureExchangeConfig} from "@/modules/redactor/models/smart-offer/bundle-ancient-treasure/AncientTreasureExchangeConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";

export default {
  name: "r-ancient-treasure-exchange-config",
  components: {RCurrencyKindDropdown, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Exchange Config"),
    model: VueTypes.instanceOf(AncientTreasureExchangeConfig),
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new AncientTreasureExchangeConfig();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}

</script>